// extracted by mini-css-extract-plugin
module.exports = {"geometry":"Geometry-module--geometry--EYG1X"};